import { Formik } from "formik"
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap"
import { Button } from "@inmagik/magik-ui"
import { useMemo } from "react"
import type { RecordMedia } from "../../types"
import { initialValuesMediaDocument, validationSchemaMediaDocument } from "./MediaDocumentCommon"
import MediaDocumentForm from "./MediaDocumentForm"

export default function MediaDocumentModal({
  title,
  id,
  mediaDocument,
  save,
  show,
  onClose,
}: {
  title: string
  id: number | undefined
  mediaDocument?: RecordMedia
  save: (values: RecordMedia, actions: { setErrors: (errors: any) => void }) => Promise<void>
  show: boolean
  onClose: () => void
}) {
  const initialValues = useMemo(() => initialValuesMediaDocument(mediaDocument) as RecordMedia, [mediaDocument])
  const validationSchema = useMemo(() => validationSchemaMediaDocument(), [])

  return (
    <Formik enableReinitialize initialValues={initialValues} validationSchema={validationSchema} onSubmit={save}>
      {({ handleSubmit }) => (
        <Modal centered show={show} onHide={onClose} size="lg" backdrop="static">
          <form onSubmit={handleSubmit}>
            <ModalHeader>
              <ModalTitle>{title}</ModalTitle>
            </ModalHeader>
            <ModalBody
              style={{
                maxHeight: "calc(100vh - 200px)",
                overflowY: "auto",
              }}
            >
              <MediaDocumentForm col={12} id={id} />
            </ModalBody>
            <ModalFooter className="d-flex justify-content-between">
              <Button onClick={onClose} title="Annulla" size="md" outline leadingIcon="close" />
              <Button type="submit" title="Salva" size="md" leadingIcon="check" className="text-white" />
            </ModalFooter>
          </form>
        </Modal>
      )}
    </Formik>
  )
}
